import React from "react"
import {RecaptchaV3Provider} from "./google-v3"
// import { RecaptchaV2Provider } from "./v2" // implement in future

/**
 * @component
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
const RecaptchaProvider = ({children}) => {
  return (
    <RecaptchaV3Provider
      siteKey={process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY_V3 ?? ""}
    >
      {children}
    </RecaptchaV3Provider>
  )
}

export default RecaptchaProvider
